import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";
import Slider from 'rc-slider';

import EmptyState from '../../../../Common/EmptyState.jsx';
import MediaRating from '../../../../Common/Blocks/MediaRating';
import ArticlesBreakdown from '../../../../Common/Blocks/ArticlesBreakdown';
import VehicleCell from '../../Vehicle/VehicleCell';
import BookingDateAndTime from '../../../../Common/Blocks/BookingDateAndTime';
import MediaActionsComponent from '../../../../Stakeholder/MediaActionsComponent.jsx';

import Chip from '../../../../Common/DesignSystem/Chips';
import { P3Bold } from '../../../../Common/DesignSystem/Text';
import ProfileCell from '../../User/ProfileCell';

import { Trans } from 'react-i18next';
import { Tabs, TabItem } from '../../../../Common/DesignSystem/Tabs.jsx';
import colours from '../../../../Common/DesignSystem/Colours.jsx';
import UserMediaRow from '../../../../Common/DesignSystem/TableRows/UserMediaRow.jsx';
import { setList, setOverlay } from '../../../../../Actions/stakeholderActions.js';

class ProfileMediaTab extends Component {
    constructor(props) {
        super(props);

        this.changeTab = this.changeTab.bind(this);
        this.renderTable = this.renderTable.bind(this);
        this.onAddCallback = this.onAddCallback.bind(this);
        this.onDismissCallback = this.onDismissCallback.bind(this);

        this.state = {
            tab: "All",
            media: [],
            completed: [],
            outstanding: [],
            dismissed: []
        };
    }

    componentDidMount() {
        let total = [];
        let n_outstanding = [];
        let n_completed = [];
        let n_dismissed = [];

        this.props.profile_details.media.outstanding.map((media)=> {
            let new_media = media;
            new_media['tab'] = 'outstanding';
            total.push(new_media);
            n_outstanding.push(new_media);
        })
        this.props.profile_details.media.complete.map((media)=> {
            //need to add contents of 'booking' object to root media object
            let new_media = media;
            let booking_obj = new_media.booking;
            Object.assign(new_media, booking_obj);
            new_media['booking'] = undefined;
            new_media['tab'] = 'completed';
            total.push(new_media);
            n_completed.push(new_media);
        })
        this.props.profile_details.media.dismissed.map((media)=> {
            let new_media = media;
            new_media['tab'] = 'dismissed';
            total.push(new_media);
            n_dismissed.push(new_media);
        })
        this.setState({media: total, completed: n_completed, outstanding: n_outstanding, dismissed: n_dismissed});
    }

    onAddCallback(booking) {
        let self = this;

        self.props.history.push(self.props.match.url + '/media_modal/' + booking.BOOK_ID + '/create');
    }

    onDismissCallback(booking) {
        var self = this;

        axios.get('/ajax/media_reminders/dismissSH/' + booking.BOOK_ID)
        .then((response) => {

            axios({
                method: 'post',
                url: '/ajax/medialist/outstanding'
            })
            .then(function(response2) {
                self.props.dispatch(setList("SET_OUTSTANDING_MEDIA_LIST", response2.data.outstanding_bookings))
            })
            .catch(function(error) {
                if (error && error.response) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                }
            })
            
            axios({
                method: 'post',
                url: '/ajax/medialist/dismissed'
            })
            .then(function(response2) {
                self.props.dispatch(setList("SET_DISMISSED_MEDIA_LIST", response2.data.dismissed_bookings))
            })
            .catch(function(error) {
                if (error && error.response) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                }
            })

            if (self.props.stakeholder.current_profile_details && self.props.profile_details.profile && self.props.profile_details.profile.ID === self.props.stakeholder.current_profile_details.profile.ID) {
                axios.get('/ajax/profile/' + self.props.profile_details.profile.ID)
                .then(function(response2) {
                    self.props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }
            let tempout = self.state.outstanding;
            let out_index = self.findBooking(tempout, booking.BOOK_ID);
            
            let tempdis = self.state.dismissed;
            let tempmedia = self.state.media;
            let media_index = self.findBooking(tempmedia, booking.BOOK_ID);


            let temp_booking = self.state.outstanding[out_index];
            temp_booking['tab'] = 'dismissed';

            tempdis.push(temp_booking);
            tempmedia.splice(media_index, 1);
            tempmedia.push(temp_booking);
            tempout.splice(out_index, 1);

            self.setState({outstanding: tempout, dismissed: tempdis, media: tempmedia});
            showStatusMsg(response?.data.message, 'success');
        })
        .catch(function(error) {
            if (error && error.response) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            }
        })
    }

    findBooking(array, ID) {
        let testcase = (element) => element.BOOK_ID == ID;
        return array.findIndex(testcase);
    }

    changeTab(id) {
        this.setState({
            tab: id
        });
    }

    renderTable() {
        if (this.state.tab === "All") {
            if((this.state.media).length === 0) {
                return(
                    <div className="full_container media_container">
                        <div className="middled_item">
                            <EmptyState image = "Media_Inactive.svg" text = "No Outstanding Media"/>
                        </div>
                    </div>
                )
            } 
            else {
                return(
                    <table className = "information-table">                                
                        <thead>
                            <tr className = "table-header">
                                <th className="align-center"><Trans>Status</Trans></th>
                                <th><Trans>Vehicle</Trans></th>
                                <th><Trans>Booking Date</Trans></th>
                                <th><Trans>Since Booking</Trans></th>
                                <th><Trans>Date Published</Trans></th>
                                <th className="align-center"><Trans>Rating</Trans></th>
                                <th className="align-center"><Trans>Actions</Trans></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.media.map((booking, index) => {
                                    return(
                                        <UserMediaRow booking={booking} alt={index % 2 === 0} match={this.props.match} history={this.props.history} onDismiss={this.onDismissCallback} onAdd={this.onAddCallback} key={booking.tab + "_" + booking.BOOK_ID}/>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                )
            }
        } else if (this.state.tab === "Outstanding") {
            if((this.state.outstanding).length === 0) {
                return(
                    <div className="full_container media_container">
                        <div className="middled_item">
                            <EmptyState image = "Media_Inactive.svg" text = "No Outstanding Media"/>
                        </div>
                    </div>
                )
            } 
            else {
                return(
                    <table className = "information-table">                                
                        <thead>
                            <tr className = "table-header">
                                <th className="align-center"><Trans>Status</Trans></th>
                                <th><Trans>Vehicle</Trans></th>
                                <th><Trans>Booking Date</Trans></th>
                                <th><Trans>Since Booking</Trans></th>
                                <th><Trans>Date Published</Trans></th>
                                <th className="align-center"><Trans>Rating</Trans></th>
                                <th className="align-center"><Trans>Actions</Trans></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.outstanding.map((booking, index) => {
                                    return(
                                        <UserMediaRow booking={booking} alt={index % 2 === 0} match={this.props.match} history={this.props.history} onDismiss={this.onDismissCallback} onAdd={this.onAddCallback} key={booking.tab + "_" + booking.BOOK_ID}/>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                )
            }
        } else if (this.state.tab === "Completed") {
            if((this.state.completed).length === 0) {
                return(
                    <div className="full_container media_container">
                        <div className="middled_item">
                            <EmptyState image = "Media_Inactive.svg" text = "No Completed Media"/>
                        </div>
                    </div>
                )
            } 
            else {
                return(
                    <table className = "information-table">                                
                        <thead>
                            <tr className = "table-header">
                                <th className="align-center"><Trans>Status</Trans></th>
                                <th><Trans>Vehicle</Trans></th>
                                <th><Trans>Booking Date</Trans></th>
                                <th><Trans>Since Booking</Trans></th>
                                <th><Trans>Date Published</Trans></th>
                                <th className="align-center"><Trans>Rating</Trans></th>
                                <th className="align-center"><Trans>Actions</Trans></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.completed.map((booking, index) => {
                                    return(
                                        <UserMediaRow booking={booking} alt={index % 2 === 0} match={this.props.match} history={this.props.history} onDismiss={this.onDismissCallback} onAdd={this.onAddCallback} key={booking.tab + "_" + booking.BOOK_ID}/>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                )
            }
        } else if (this.state.tab === "Dismissed") {
            if((this.state.dismissed).length === 0) {
                return(
                    <div className="full_container media_container">
                        <div className="middled_item">
                            <EmptyState image = "Media_Inactive.svg" text = "No Dismissed Media"/>
                        </div>
                    </div>
                )
            } 
            else {
                return(
                    <table className = "information-table">                                
                        <thead>
                            <tr className = "table-header">
                                <th className="align-center"><Trans>Status</Trans></th>
                                <th><Trans>Vehicle</Trans></th>
                                <th><Trans>Booking Date</Trans></th>
                                <th><Trans>Since Booking</Trans></th>
                                <th><Trans>Date Published</Trans></th>
                                <th className="align-center"><Trans>Rating</Trans></th>
                                <th className="align-center"><Trans>Actions</Trans></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.dismissed.map((booking, index) => {
                                    return(
                                        <UserMediaRow booking={booking} alt={index % 2 === 0} match={this.props.match} history={this.props.history} onDismiss={this.onDismissCallback} onAdd={this.onAddCallback} key={booking.tab + "_" + booking.BOOK_ID}/>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                )
            }
        }
    }

    render(props) {
        return(
            <div className="row expanded bkg-white-dark">
                <div className="columns large-12 medium-12 small-12">
                    <div className="ds-card">
                        <div className="border-bottom" style={{paddingBottom: 16}}>
                            <Tabs value={this.state.tab} onChange={(e) => {this.changeTab(e.currentTarget.dataset.id)}}>
                                <TabItem label="All"/>
                                <TabItem label="Outstanding"/>
                                <TabItem label="Completed"/>
                                <TabItem label="Dismissed"/>
                            </Tabs>
                        </div>
                        <div>
                            {this.renderTable()}
                        </div>
                        <div className = "clearfix"></div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    data: store.data,
    userSession: store.userSession,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(ProfileMediaTab)